import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSuffix } from '@angular/material/form-field';
import { MatFormField, MatLabel } from '@angular/material/input';
import { MatOption, MatSelect } from '@angular/material/select';
import { TranslocoPipe } from '@jsverse/transloco';
import { FilterClearButtonComponent } from '../filter-clear-button.component';
import { AbstractFilterComponent } from './abstract-filter.component';
import { I18nProviderInjectionToken } from '@pct-ng/i18n';

@Component({
  selector: 'cappus-filter-is-highlighted',
  imports: [
    MatFormField,
    MatLabel,
    MatSelect,
    MatOption,
    ReactiveFormsModule,
    MatSuffix,
    TranslocoPipe,
    FilterClearButtonComponent,
  ],
  templateUrl: './filter-is-highlighted.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterIsHighlightedComponent extends AbstractFilterComponent<boolean | null> {
  protected readonly coreI18nCommonScope = `${I18nProviderInjectionToken.scope}.COMMON.`;
}
